import React, { Component } from 'react';
import styled from 'styled-components';
import Up from 'react-icons/lib/md/keyboard-arrow-up';
import scrollToComponent from 'react-scroll-to-component';
import Dimmed from 'components/Shared/Dimmed';
import MenuBar from 'react-icons/lib/md/dehaze';
import MenuClose from 'react-icons/lib/md/close';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import CSSTransition from 'react-transition-group/CSSTransition';

import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as uiActions from 'modules/ui';
import { Flex, media } from 'lib/style-utils';

import MobileMenu from './MobileMenu';
import 'lib/toggleTransition.css';

const Container = styled.div`
  width: 100%;
`;

const Wrapper = Flex.extend`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;
  box-sizing: border-box;

  width: 100%;
  height: 82px;
  padding: 8px 0 0;
  z-index: 30;
  overflow: hidden;
  transition: all 1s ease-in-out;

  box-shadow: ${props =>
    props.isWhiteNav
      ? '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'
      : null};
  background: ${props => (props.isWhiteNav ? 'white' : null)};

  /** Mobile Menu Button */
  & .menu-btn {
    display: none;
  }

  ${media.tablet`
    & .menu-btn, .close-btn {
      display: inline-block;
      position: fixed;
      top: 16px;
      right: 20px;
      font-size: 40px;
      cursor: pointer;
      z-index: 20;
      backface-visibility: hidden;
    }

    justify-content: space-between;
    padding: 8px 0 3px;
  `} ${media.mobile`
    height: 77px;
    padding: 15px 0;

    & .menu-btn, .close-btn {
      top: 19px;
      font-size: 32px;
    }
  `};
`;

/** Brand Logo */
const Logo = styled.div`
  margin: 0 0 0 16px;
  z-index: 99;

  ${media.mobile`
    width: 35%;
    margin-left: 15px;
  `};
`;

const Smafolk = styled.img`
  width: 304px;
  transform-style: preserve-3d;
  backface-visibility: hidden;
  transition: all 0.3s;

  ${media.tablet`
    width: 240px;
  `};
`;

/** Navigation Link */
const Nav = Flex.extend`
  margin-top: -8px;
  width: 40%;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;

  ${media.tablet`
    display: none;
  `};
`;

const NavList = styled.div`
  font-size: 17px;
  font-weight: bold;
  letter-spacing: 0.4px;
  color: #424242;
  transition: all 0.3s;

  ${media.w1200`
    font-size: 16px;
  `};
`;

const BtnNav = Flex.extend`
  margin-top: -10px;
  width: 360px;
  height: 45px;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-around;

  ${media.w1440`
    width: 315px;
  `}
  ${media.w1200`
    width: 260px;
  `}
  ${media.tablet`
    display: none;
  `}
`;

const Btn = styled.button`
  display: inline-block;
  padding: 0px 30px;
  height: 45px;
  background: #ffffff;
  color: #999999;
  border: 1px solid #eeeeee;
  border-radius: 23px;
  text-align: center;
  font-size: 15px;
  letter-spacing: 1.2px;
  cursor: pointer;

  &:hover {
    background: #f9f9f9;
  }

  &:active {
    background: #f2f2f2;
  }

  ${media.w1200`
    padding: 0px 20px;
    font-size: 14px;
    height: 40px;
  `}
  ${media.tablet`
    padding: 0px 32px;
    font-size: 15px;
  `}
  ${media.mobile`
    padding: 0px 32px;
  `}
`;

/** React-Router Styling */
const activeStyle = () => {
  if (window.innerWidth < 1024) {
    return {
      paddingTop: '20px',
      borderTop: '5px solid black'
    };
  } else {
    return {
      paddingTop: '26px',
      borderTop: '5px solid black'
    };
  }
};

/** To Top Button */
const BtnWrapper = styled.div`
  position: fixed;
  right: 72px;
  bottom: 50px;
  z-index: 20;

  ${media.w1200`
    right: 40px;
  `}
  ${media.mobile`
    right: 20px;
  `}
  ${media.iphone67p`
    right: 10px;
  `}
  ${media.iphone67`
    right: 10px;
  `}
`;

const UpButton = Flex.extend`
  width: 50px;
  height: 50px;
  font-size: 42px;
  color: #aaaaaa;
  background: #ffffff;
  border-radius: 50%;
  border: solid 1px #eeeeee;
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: all 0.3s;

  &:active {
    box-shadow: none;
  }
`;

class Header extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps;
  }

  componentDidMount() {
    const iOS =
      !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

    if (iOS) {
      if ('scrollRestoration' in window.history) {
        this._oldScrollRestoration = window.history.scrollRestoration;
        window.history.scrollRestoration = 'manual';
      } else {
        this._oldScrollRestoration = null;
      }
    }

    window.addEventListener('scroll', this.handleScroll);
  }

  handleScroll = e => {
    const { innerHeight } = window;
    const scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    const { isWhiteNav, appearUp } = this.props;
    const { whiteNav, topNav, showUp, hideUp } = this.props.UIActions;

    if (scrollTop > 100 && !isWhiteNav) {
      whiteNav();
    } else if (scrollTop <= 100 && isWhiteNav) {
      topNav();
    }

    if (!appearUp && scrollTop > innerHeight) {
      showUp();
    } else if (appearUp && scrollTop <= innerHeight) {
      hideUp();
    }
  };

  handleScrollTop = () => {
    window.scrollTo(0, 0);
    this.handleAnotherBrands();
  };

  handleAnotherBrands = () => {
    const { showAnotherBrands } = this.props;
    const { hideAnother } = this.props.UIActions;

    if (showAnotherBrands) {
      hideAnother();
    }
  };

  handleClickMobileNav = () => {
    this.handleHideMenu();
    this.handleScrollTop();
    this.handleAnotherBrands();
  };

  handleScrollTopButton = () => {
    scrollToComponent(document.body, {
      offset: 0,
      align: 'top',
      duration: 500
    });
  };

  preventScroll = e => {
    e.preventDefault();
  };

  handleShowMenu = () => {
    const { UIActions, showMenu } = this.props;

    if (!showMenu) {
      UIActions.showMenu();
      document.body.style['overflow'] = 'hidden';
      document.body.addEventListener('touchmove', this.preventScroll, {
        passive: false
      });
    }
  };

  handleHideMenu = () => {
    const { UIActions, showMenu } = this.props;

    if (showMenu) {
      UIActions.hideMenu();
      document.body.style['overflow'] = 'auto';
      document.body.removeEventListener('touchmove', this.preventScroll, {
        passive: false
      });
    }
  };

  render() {
    const { isWhiteNav, showMenu, appearUp } = this.props;
    const {
      handleScrollTop,
      handleScrollTopButton,
      handleShowMenu,
      handleHideMenu,
      handleClickMobileNav
    } = this;

    return (
      <Container>
        <Wrapper isWhiteNav={isWhiteNav}>
          <Logo>
            <NavLink to="/" onClick={handleClickMobileNav}>
              <Smafolk src="/images/logo/logo.png" alt="" />
            </NavLink>
          </Logo>

          <TransitionGroup>
            {showMenu ? null : (
              <CSSTransition
                classNames="open"
                timeout={{ enter: 300, exit: 300 }}
              >
                <div className="menu-btn" onClick={handleShowMenu}>
                  <MenuBar />
                </div>
              </CSSTransition>
            )}
            {showMenu ? (
              <CSSTransition
                classNames="close"
                timeout={{ enter: 400, exit: 300 }}
              >
                <div className="close-btn" onClick={handleHideMenu}>
                  <MenuClose />
                </div>
              </CSSTransition>
            ) : null}
          </TransitionGroup>

          <Nav>
            <NavList>
              <NavLink
                to="/about"
                activeStyle={activeStyle()}
                onClick={handleScrollTop}
              >
                ABOUT
              </NavLink>
            </NavList>
            <NavList>
              <NavLink
                to="/lookbook"
                activeStyle={activeStyle()}
                onClick={handleScrollTop}
              >
                LOOK BOOK
              </NavLink>
            </NavList>
            <NavList>
              <NavLink
                to="/shoplist"
                activeStyle={activeStyle()}
                onClick={handleScrollTop}
              >
                SHOP LIST
              </NavLink>
            </NavList>
            <NavList>
              <NavLink
                to="/contact"
                activeStyle={activeStyle()}
                onClick={handleScrollTop}
              >
                CONTACT
              </NavLink>
            </NavList>
          </Nav>

          <BtnNav>
            <a
              href="http://www.gurmbyh.com/product/list.html?cate_no=115"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Btn>SHOP</Btn>
            </a>
            <a
              href="http://www.gurmbyh.co.jp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Btn>GO JAPAN</Btn>
            </a>
          </BtnNav>
        </Wrapper>

        <TransitionGroup>
          {showMenu ? (
            <CSSTransition
              classNames="dimmed"
              timeout={{ enter: 300, exit: 300 }}
            >
              <Dimmed />
            </CSSTransition>
          ) : null}
        </TransitionGroup>

        <MobileMenu
          showMenu={showMenu}
          hideMenu={handleHideMenu}
          handleClick={handleClickMobileNav}
        />

        <TransitionGroup>
          {appearUp ? (
            <CSSTransition
              classNames="toggle"
              timeout={{ enter: 600, exit: 500 }}
            >
              <BtnWrapper>
                <UpButton onClick={handleScrollTopButton}>
                  <Up />
                </UpButton>
              </BtnWrapper>
            </CSSTransition>
          ) : null}
        </TransitionGroup>
      </Container>
    );
  }
}

export default connect(
  state => ({
    isWhiteNav: state.ui.get('isWhiteNav'),
    showMenu: state.ui.get('showMenu'),
    appearUp: state.ui.get('appearUp'),
    showAnotherBrands: state.ui.get('showAnotherBrands')
  }),
  dispatch => ({
    UIActions: bindActionCreators(uiActions, dispatch)
  })
)(Header);



// WEBPACK FOOTER //
// ./src/components/Shared/Header.js